import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(frontend)/contact/page.client.tsx");
